import { _t } from '@bark/bark-core';

export function BarkMessengerV11() {
	var currentRoom;

	function determineRoom() {
		return getBuyerRoom();
	}

	var buyerHasInteracted = false;
	var disableNewMessages = false;

	var quickActionsSet = false;
	function showQuickActions() {
		if ($('.messenger-container').data('seller-dismissed') != 0) {
			$('.js-quick-actions-message').hide();
			$('.js-quick-actions-header').hide();
			$('.js-quick-action-select').hide();
			return false;
		}
		if (buyerHasInteracted) {
			$('.js-quick-actions-message').hide();
			// check there are some quick actions to show
			if ($('.js-quick-actions-header .js-quick-action-button').length > 0) {
				$('.js-quick-actions-header').show();
				$('.js-quick-action-select').show();
			}
		} else {
			$('.js-quick-actions-message').show();
			$('.js-quick-actions-header').hide();
			$('.js-quick-action-select').hide();
		}
		quickActionsSet = true;
		return true;
	}

	function getBuyerRoom() {
		var response_id = $('#buyer-messenger').attr('data-active-id');
		var buyer_id = $('#buyer-messenger').attr('data-buyer-id');
		var seller_id = $('#buyer-messenger').attr('data-seller-id');
		return 'r_' + response_id + '_b_' + buyer_id + '_s_' + seller_id;
	}

	function applyResponseAction(type, data, project_response_id) {
		const $buyerMessenger = $('#buyer-messenger');
		const bpvs = $buyerMessenger.data('bpvs');
		const bmvi = $buyerMessenger.data('bmvi');
		const projectHash = $buyerMessenger.data('projectHash');
		const sellerProfileHash = $buyerMessenger.data('sellerProfileHash');

		const payload = {
			...data,
			action: type,
			source: 'messenger',
			bpvs,
			bmvi,
		};

		data.type = type;
		data.source = 'messenger';
		data.bpvs = bpvs;
		data.bmvi = bmvi;

		Bark.api(
			`/buyer/project/${projectHash}/sellers/${sellerProfileHash}/actions`,
			payload,
			function (answer) {
				buyerHasInteracted = true;

				switch (type) {
					case 'dismiss':
						$('.js-response-message-container').hide();
						$('.js-messenger-blocked-container').fadeIn();
						$('.messenger-container').data('seller-dismissed', 1);

						$('.js-show-dismissed').show();
						$('#dismissPro').foundation('reveal', 'close');
					// intentional fallthrough
					case 'hired':
						$('.js-job-status-buttons').hide();
						if (type === 'hired') {
							$('.js-show-hired').show();
							$('#hirePro').foundation('reveal', 'close');
						}
						$('.js-quick-actions-message').hide();
						$('.js-quick-actions-header').hide();
						$('.js-quick-action-select').hide();
						break;
					case 'call-me':
						$('.js-request-callback')
							.addClass('disabled inactive')
							.prop('disabled', true)
							.find('.action-button-text')
							.text(_t('buyer_messenger:callback-requested'));
						$('#action-call-me').foundation('reveal', 'close');
						break;
					case 'quote':
						$('.js-request-quote')
							.addClass('disabled inactive')
							.prop('disabled', true)
							.find('.action-button-text')
							.text(_t('buyer_messenger:quote-requested'));
				}

				if ($('#buyer-messenger').length) {
					data.is_buyer = 1;
					data.room = getBuyerRoom();
				}

				data = actionType(data);
				data = addDateString(data);
				data.created = new Date().valueOf() / 1000;
				data.message_type = 'action';
				BarkMessenger.messengerEvents.fireEvent('buyer_response_action', type);
				rebindResponseActions();
			},
			function (e) {
				window.Bark.alertModal(
					_t('buyer_messenger:error-occurred'),
					_t('buyer_messenger:ok-button'),
					() => window.location.reload(),
				);
				var meta = {
					data: data,
					statusCode: e.status,
					responseText: e.responseText ? e.responseText : '',
					responseJSON: e.responseJSON ? e.responseJSON : '',
				};
				bugsnagClient.notify(new Error('add-response-action:failed'), {
					metaData: { additional: meta },
					severity: 'error',
				});
			},
			'POST',
		);

		BarkMessenger.messages.scrollToNewest();
	}

	function rebindResponseActions() {
		$('.js-action-view-contact')
			.unbind()
			.click(function () {
				$(this).fadeOut(function () {
					$('.js-company-contact-details').fadeIn();
				});
				applyResponseAction(
					'contact-details-viewed',
					{ data: null },
					$('#buyer-messenger').attr('data-active-id'),
				);
			});

		$('.js-action-view-website')
			.unbind()
			.click(function () {
				applyResponseAction(
					'website-view',
					{ data: null },
					$('#buyer-messenger').attr('data-active-id'),
				);
			});

		$('.js-action-view-profile')
			.unbind()
			.click(function () {
				applyResponseAction(
					'profile-view',
					{ data: null },
					$('#buyer-messenger').attr('data-active-id'),
				);
			});

		$('.js-quick-action-more').click(function () {
			$(this).hide();
			$(this)
				.closest('.js-quick-action-container')
				.find('.js-more-quick-action')
				.removeClass('hide');
		});

		$('.js-dismiss-seller')
			.unbind()
			.click(function () {
				$('#dismissPro').foundation('reveal', 'open');
			});

		$('.js-hired-seller')
			.unbind()
			.click(function () {
				$('#hirePro').foundation('reveal', 'open');
			});

		$('#action-hire-pro')
			.unbind()
			.click(function () {
				if (!$(this).hasClass('disabled') && !$(this).hasClass('perma-disabled')) {
					let data = {
						review_rating: $("input[name='selected-rating']").val(),
						review_text: $("textarea[name='modal_textarea']").val(),
					};
					if (parseInt(data.review_rating) > 0 && data.review_text.length < 30) {
						$('#modal_text_error').text(`* ${_t('buyer_messenger:hired-pro-modal.minimum-characters-for-review')}`).show();
						$('#modal_text_error').parent().addClass('new-error');
					} else {
						applyResponseAction(
							'hired',
							data,
							$('#buyer-messenger').attr('data-active-id'),
						);
						$('#modal_text_error').hide();
					}
				}
			});

		$('#action-dismiss-pro')
			.unbind()
			.click(function () {
				if (!$(this).hasClass('disabled') && !$(this).hasClass('perma-disabled')) {
					let data = {
						data: $('#dismissPro').find("input[name='dismiss']:checked").val(),
					};
					if (data.data === 'other') {
						data.data = $('#dismiss-text').val();
					}
					applyResponseAction(
						'dismiss',
						data,
						$('#buyer-messenger').attr('data-active-id'),
					);
				}
			});

		$('.js-request-callback')
			.unbind()
			.click(function () {
				$('#callMe').foundation('reveal', 'open');
				$('#telephone-error').hide();
				$('#telephone-selection-error').hide();
				$('#telephone-selection-error').parent().removeClass('new-error');
				$('#telephone-error').parent().removeClass('new-error');
				$('#callMe').find("input[name='call']").removeAttr('checked');
				$('#callme-text').val('');
			});

		$('.js-send-email')
			.unbind()
			.click(function () {
				$('#send-email-modal').foundation('reveal', 'open');
			});

		$('#callme-text').click(function () {
			$('#callMe input[value=other]').prop('checked', true);
		});

		$('.js-request-quote')
			.unbind()
			.click(function () {
				applyResponseAction(
					'quote',
					{ data: null },
					$('#buyer-messenger').attr('data-active-id'),
				);
			});

		$('.js-show-profile-panel')
			.unbind()
			.click(function () {
				if (!$('.js-seller-profile-panel').is(':visible')) {
					$('.js-seller-profile-panel').removeClass('collapsed-seller-panel-hide');
					$('.js-chat-panel').addClass('collapsed-seller-panel-hide');
				}
			});

		$('.js-show-chat-panel')
			.unbind()
			.click(function () {
				$('.js-seller-profile-panel').addClass('collapsed-seller-panel-hide');
				$('.js-chat-panel').removeClass('collapsed-seller-panel-hide');
			});

		$('.js-custom-message')
			.unbind()
			.click(function () {
				var message = $(this).data('message'),
					suggestedMessageId = $(this).data('suggested-message-id');
				if (message) {
					$('.message-box').val(message);
					$('.post-message')
						.data('suggested-message-id', $(this).data('suggested-message-id'))
						.removeClass('disabled')
						.trigger('click');
					$(
						'.js-custom-message[data-suggested-message-id="' + suggestedMessageId + '"]',
					).remove();
				}
			});
		var buyerEmailSellerModal = $('#send-email-modal');
		$('#action-send-email', buyerEmailSellerModal)
			.off('click.sendEmail')
			.on('click.sendEmail', function () {
				var msg = $('[name=message]', buyerEmailSellerModal).val();
				if (msg.length > 10) {
					submitSendEmailForm();
				} else {
					$('.error-container', buyerEmailSellerModal)
						.removeClass('d-none')
						.text(_t('buyer_messenger:send-email-modal.errors.enter-longer-message'));
				}
			});
		/**
		 * Submit the contact form to the API endpoint
		 */
		function submitSendEmailForm() {
			$('.error-container', buyerEmailSellerModal).addClass('d-none');
			var payload = {
				message: $('[name=message]', buyerEmailSellerModal).val(),
				project_id: $('[name=pid]', buyerEmailSellerModal).val(),
				seller_profile_id: $('[name=spid]', buyerEmailSellerModal).val(),
				bpvs: $('[name=bpvs]', buyerEmailSellerModal).val(),
				email: $('[name=buyer_email]', buyerEmailSellerModal).val(),
				type: 'message',
			};
			setSubmittedState(true);
			Bark.api(
				'seller/contact',
				payload,
				function (data) {
					if (data.status) {
						toggleConfirmationMessage(true);

						$('html, body').animate(
							{
								scrollTop: 0,
							},
							250,
						);

						BarkMessenger.messengerEvents.fireEvent('buyer_sent_email');
						// Auto-close the modal in 2 seconds
						window.setTimeout(function () {
							$('#send-email-modal').foundation('reveal', 'close');
							window.setTimeout(function () {
								toggleConfirmationMessage(false);
							}, 1000);
						}, 2000);
					} else {
						$('.error-container', buyerEmailSellerModal)
							.removeClass('d-none')
							.text('Submission failed. Please try again.');
					}
					setSubmittedState(false);
				},
				function (error) {
					var errors = [];
					if (
						error.responseJSON &&
						error.responseJSON.error &&
						error.responseJSON.error.errors
					) {
						for (var field in error.responseJSON.error.errors) {
							errors.push(error.responseJSON.error.errors[field]);
						}
					}
					if (!errors.length && error.responseJSON && error.responseJSON.message) {
						errors.push(error.responseJSON.message);
					}
					$('.error-container', buyerEmailSellerModal)
						.removeClass('d-none')
						.text(errors.join(' '));
					setSubmittedState(false);
				},
				'POST',
				Bark.apiVersionHeader('v2'),
			);
		}
		function toggleConfirmationMessage(showConfirmation) {
			$('.send-email-modal-content', buyerEmailSellerModal)[
				showConfirmation ? 'addClass' : 'removeClass'
			]('d-none');
			$('.confirmation-container', buyerEmailSellerModal)[
				showConfirmation ? 'removeClass' : 'addClass'
			]('d-none');

			// Reset the form
			if (!showConfirmation) {
				$('textarea', buyerEmailSellerModal).each(function () {
					$(this).val(null);
				});
				resetContactValidationMessages();
			}
		}
		/**
		 * Clears all validation error messages and classes
		 */
		function resetContactValidationMessages() {
			$('.error-container', buyerEmailSellerModal).addClass('d-none');
			$('.invalid-feedback', buyerEmailSellerModal).hide();
			$('.is-invalid', buyerEmailSellerModal).removeClass('is-invalid');
		}

		/**
		 * Disable the submit and close buttons
		 * @param {boolean} isSubmitting If true, disable submit buttons and show submitting status, otherwise reset
		 */
		function setSubmittedState(isSubmitting) {
			$('#action-send-email', buyerEmailSellerModal).attr(
				'disabled',
				isSubmitting ? true : false,
			);
		}
		$('#action-call-me')
			.unbind()
			.click(function () {
				if (!$(this).hasClass('disabled') && !$(this).hasClass('perma-disabled')) {
					$('#telephone-error, #telephone-selection-error').hide();
					validatePhoneNumber(
						$('#callme-telephone-text').val(),
						function (validationResult) {
							if (
								!validationResult ||
								$('#callMe').find("input[name='call']:checked").val() === undefined
							) {
								if (!validationResult) {
									$('#telephone-error').show();
									$('#telephone-error').parent().addClass('new-error');
								}

								if ($('#callMe').find("input[name='call']:checked").val() === undefined) {
									$('#telephone-selection-error').show();
									$('#telephone-selection-error').parent().addClass('new-error');
								}
							} else {
								var data = {
									data:
										'Please call me ' +
										$('#callMe').find("input[name='call']:checked").val() +
										' on ' +
										$('#callme-telephone-text').val(),
								};

								if ($('#callMe').find("input[name='call']:checked").val() == 'other') {
									if ($('#callme-text').val().length > 0) {
										data.data =
											'Please call me ' +
											$('#callme-text').val() +
											' on ' +
											$('#callme-telephone-text').val();
									} else {
										data.data =
											'Please call me soon on ' + $('#callme-telephone-text').val();
									}
								}
								applyResponseAction(
									'call-me',
									{ data },
									$('#buyer-messenger').attr('data-active-id'),
								);
							}
						},
					);
				}
			});
	}

	var Message = {
		latestDate: null,

		nth: function (d) {
			if (d > 3 && d < 21) return 'th'; // thanks kennebec
			switch (d % 10) {
				case 1:
					return 'st';
				case 2:
					return 'nd';
				case 3:
					return 'rd';
				default:
					return 'th';
			}
		},

		firstMessage: true,

		updateQuote: function (val) {
			if ($('#buyer-messenger').length) {
				if (val.quote > 0) {
					var typeText = val.quote_type;
					if (typeText === 'onceoff') {
						typeText = '';
					} else {
						typeText = '/' + typeText;
					}
					if (val.quote.slice(-3) === '.00') {
						val.quote = val.quote.slice(0, -3);
					}

					$('.js-quote-text').text(val.currency_symbol + val.quote + typeText);
					if (val.quote_detail) {
						$('.js-quote-detail').text(val.quote_detail.trim());
						$('.js-quote-show-detail').removeClass('hide');
					} else {
						$('.js-quote-show-detail').addClass('hide');
					}
					$('.js-quote-container').removeClass('hide');
					$('.js-request-quote').remove();
				} else {
					$('.js-quote-container').addClass('hide');
				}
			}
		},
	};

	function validatePhoneNumber(inputtxt, callback) {
		$.post(
			'/validate-uk-phone-ajax/',
			{ telephone: inputtxt },
			function (data) {
				if (data.success === true) {
					callback(true);
				} else {
					callback(false);
				}
			},
			'json',
		);
	}

	function selectList(responseId) {

		if (responseId !== '') {
			$('#buyer-messenger').attr('data-active-id', responseId);

			$('.messenger-container').hide();
			$('.messenger-container#' + responseId).show();

			window.location.hash = '#' + responseId;

			if ($("#buyer-notifications>li[data-response-id='" + responseId + "']").length) {
				$("#buyer-notifications>li[data-response-id='" + responseId + "']").remove();
				$('.buyer-notification>span').text(
					$('#buyer-notifications>li.notification-item').length,
				);
				if ($('#buyer-notifications>li.notification-item').length === 0) {
					$('.buyer-notification>span').hide();
				}
			}
		}

		currentRoom = getBuyerRoom();
	}

	function actionType(data) {
		if (data.is_buyer) {
			switch (data.type) {
				case 'hired':
					data.action_text = 'You hired this pro';
					break;
				case 'contact-later':
					data.action_text = 'You will contact this pro later';
					break;
				case 'dismiss':
					data.action_text = "You declined this pro's offer";
					if (data.data !== undefined) {
						if (data.data.length) {
							data.action_text += ' (' + data.data + ')';
						}
					}
					break;
				case 'call-me':
					data.action_text = data.data.data.replace(
						'Please call me',
						'You requested a call',
					);
					break;
				case 'website-view':
					data.action_text = "You viewed this pro's website";
					break;
				case 'contact-details-viewed':
					data.action_text = "You viewed this pro's contact details";
					break;
				case 'profile-view':
					data.action_text = "You viewed this pro's profile";
					break;
				case 'message-later':
					data.action_text = 'The seller will contact you soon';
					break;
				case 'quote':
					data.action_text = 'You requested a quote from the seller';
					break;
			}
		} else {
			switch (data.type) {
				case 'hired':
					data.action_text = 'Great, the buyer decided to hire you!';
					break;
				case 'contact-later':
					data.action_text = 'The buyer said they will contact you later';
					break;
				case 'dismiss':
					data.action_text = 'The buyer declined your offer';
					if (data.data !== undefined && data.data.length) {
						data.action_text += ' (' + data.data + ')';
					}
					break;
				case 'call-me':
					data.action_text = $result.data;
					break;
				case 'website-view':
					data.action_text = 'The buyer viewed your website';
					break;
				case 'contact-details-viewed':
					data.action_text = 'The buyer viewed your contact details';
					break;
				case 'profile-view':
					data.action_text = 'The buyer viewed your profile';
					break;
				case 'message-later':
					data.action_text = 'You requested to contact the buyer later';
					break;
				case 'quote':
					data.action_text = 'The buyer requested a quote from you';
					break;
			}
		}
		return data;
	}

	function addDateString(data) {
		/* Time ago */
		var myDate = new Date(parseInt(data.created) * 1000);
		data.created_datestring = timeSince(myDate);
		return data;
	}

	function timeSince(date) {
		var seconds = Math.floor((new Date() - date) / 1000);
		var interval = Math.floor(seconds / 31536000);

		if (interval > 1) {
			return interval + ' years ago';
		}

		interval = Math.floor(seconds / 2592000);

		if (interval > 1) {
			return interval + ' months ago';
		}

		interval = Math.floor(seconds / 86400);

		if (interval > 1) {
			return interval + ' days ago';
		}

		interval = Math.floor(seconds / 3600);

		if (interval > 1) {
			return interval + ' hours ago';
		}

		interval = Math.floor(seconds / 60);

		if (interval > 1) {
			return interval + ' minutes ago';
		} else if (interval == 1) {
			return interval + ' minute ago';
		}

		return 'Less than a minute ago';
	}

	// Bark messenger
	const BarkMessenger = new (function () {
		// Load event
		$(window).load(function () {
			resize();
		});

		// Resize messenger
		var resize = function () {
			var header = $('#header'),
				container = $('#bark-messenger-container');

			container.css('top', header.outerHeight());
		};

		// Messages
		var messages = new (function () {
			// Scroll to newest
			var scrollToNewest = function () {
				var $messages = $('.js-messenger-all-messages');

				if (!$messages.length) {
					return;
				}
			};

			// Public
			return {
				scrollToNewest: scrollToNewest,
			};
		})();

		var messengerEvents = {
			on: function (ev, callback) {
				if (Array.isArray(ev)) {
					var pubsub = this;
					ev.forEach(function (e) {
						pubsub.on(e, callback);
					});
				} else {
					var calls = this._callbacks || (this._callbacks = {});
					(this._callbacks[ev] || (this._callbacks[ev] = [])).push(callback);
				}
				return this;
			},

			fireEvent: function () {
				var args = Array.prototype.slice.call(arguments, 0);

				var ev = args.shift();

				if (typeof window.verboseEv !== 'undefined' && window.verboseEv === true) {
					console.log(ev + ' happened');
				}

				var list, calls, i, l;

				if (!(calls = this._callbacks)) return this;
				if (!(list = this._callbacks[ev])) return this;

				for (i = 0, l = list.length; i < l; i++) list[i].apply(this, args);
				return this;
			},
		};

		// Public
		return {
			resize: resize,
			messages: messages,
			messengerEvents: messengerEvents,
		};
	})();

	function rebind() {
		$('#extend-project').on('click', function () {
			$.get(
				'/buyers/extend-project/?project_id=' + $('#extend-project').attr('data-id'),
				function () {
					window.location.reload();
				},
			);
		});

		BarkMessenger.resize();

		$('.company-desc')
			.unbind()
			.click(function () {
				if ($(this).hasClass('expanded')) {
					$(this).removeClass('expanded');
				} else {
					$(this).addClass('expanded');
				}
			});
	}

	$(document).ready(function () {
		var open_project_response_id = Number(
			(window.location.hash || '').replace('#', '') || Bark.GET('bpid'),
		);

		if (!open_project_response_id) {
			open_project_response_id = $('.messenger-container').attr('id');
		}

		$(window).resize(function () {
			BarkMessenger.resize();
		});

		if (+Bark.GET('dismiss')) {
			$('#dismissPro').foundation('reveal', 'open');
		}

		//Timeout for messengers
		if ($('#bark-messenger').length) {
			var timeoutIdUserActivity;

			function startTimer() {
				// wait 2 seconds before calling goInactive
				timeoutIdUserActivity = window.setTimeout(goInactive, 60 * 20 * 1000);
			}

			function resetTimer(e) {
				window.clearTimeout(timeoutIdUserActivity);
				startTimer();
			}

			function setup() {
				this.addEventListener('mousemove', resetTimer, false);
				this.addEventListener('mousedown', resetTimer, false);
				this.addEventListener('keypress', resetTimer, false);
				this.addEventListener('DOMMouseScroll', resetTimer, false);
				this.addEventListener('mousewheel', resetTimer, false);
				this.addEventListener('touchmove', resetTimer, false);
				this.addEventListener('MSPointerMove', resetTimer, false);
			}
			setup();

			function goInactive() {
				// do something
				if ($('#buyer-messenger').length) {
					window.location.replace('/buyers/logout');
				}
			}
		}

		rebind();
		rebindResponseActions();

		$('.js-close-quote-modal').click(function () {
			$('#quote-modal').foundation('reveal', 'close');
		});

		$('.js-shortened-text-container').each(function (i, el) {
			$(el)
				.find('.js-see-more')
				.click(function (event) {
					$(el).find('.js-shorted-text').addClass('hide');
					$(el).find('.js-full-text').removeClass('hide');
				});
			$(el)
				.find('.js-see-less')
				.click(function (event) {
					$(el).find('.js-shorted-text').removeClass('hide');
					$(el).find('.js-full-text').addClass('hide');
				});
		});

		$(this).keypress(function (e) {
			if (e.keyCode == 27) {
				return false;
			}
		});
		if ($('#buyer-dashboard').length) {
			getCombinedUpdates(0, 0);
		}

		selectList(open_project_response_id);
	});

	return BarkMessenger;
}
